import React, { useLayoutEffect, useState, useContext } from 'react';
import { FaCheck } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { PageProps } from 'types/PageProps';
import Load from 'components/Load';
import { UseTranslationProps } from 'types/UseTranslationProps';
import { getPages } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import GeneralConfigContext from 'context/GeneralConfigContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { saveGeneralConfigs } from './reqs';

interface PagesAdmProps {
	isVisiable: boolean;
}
export default function PagesAdm({ isVisiable }: PagesAdmProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { generalConfigs, setGeneralConfigs } =
		useContext(GeneralConfigContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);
	const { t }: UseTranslationProps = useTranslation();

	const [isReqPages, setIsReqPages] = useState(false);
	const [listPages, setListPages] = useState<PageProps[]>([]);

	function searchBySlug(page: PageProps) {
		if (
			generalConfigs === null ||
			generalConfigs?.non_editable_pages === null
		) {
			return false;
		}

		if (
			generalConfigs !== null &&
			generalConfigs.non_editable_pages &&
			typeof generalConfigs?.non_editable_pages === 'string'
		) {
			const value = generalConfigs!.non_editable_pages.includes(page.slug);
			return value;
		}

		return false;
	}

	//função tira ou coloca string da configuraçãod e pagina não editavel
	function toggleWord(words: string, word: string): string | null {
		const wordArray = words ? words.split(',').filter(Boolean) : [];
		const wordIndex = wordArray.indexOf(word);

		if (wordIndex !== -1) {
			// Se a palavra já existe, remove ela
			wordArray.splice(wordIndex, 1);
		} else {
			// Se não existe, adiciona
			wordArray.push(word);
		}

		const result = wordArray.join(',');
		return result.length === 0 ? null : result;
	}

	async function handleClick(value: PageProps) {
		if (generalConfigs) {
			setIsOpenLoad(true);
			setMessage('Salvando configuração');
			const { isSuccess, data } = await saveGeneralConfigs(
				toggleWord(generalConfigs?.non_editable_pages || '', value.slug),
				handleNotify
			);

			if (isSuccess && data) {
				setGeneralConfigs(data);
			}

			setIsOpenLoad(false);
		}
	}

	useLayoutEffect(() => {
		(async () => {
			setIsReqPages(true);
			const { data, isSuccess } = await getPages(handleNotify);

			if (isSuccess && data.length > 0) {
				setListPages(data);
			}

			setIsReqPages(false);
		})();
	}, []);

	return (
		<S.container $isShow={isVisiable}>
			{isReqPages ? (
				<S.centralize>
					<Load showText text="Carregando Páginas" />
				</S.centralize>
			) : (
				<>
					<S.infos>
						<h2>Páginas não editáveis</h2>
						<p>
							Selecione as páginas que não poderão ser editadas pelos usuários,
							mesmo que eles tenham permissão de edição.
						</p>
					</S.infos>

					{listPages.length > 0 ? (
						<S.list>
							{listPages.map((item) => (
								<S.item
									$isSelect={searchBySlug(item)}
									key={item.id}
									onClick={() => handleClick(item)}
								>
									<p>{t(item.name)}</p>
									{searchBySlug(item) && (
										<S.checkedItem data-testid="check-box">
											<FaCheck />
										</S.checkedItem>
									)}
								</S.item>
							))}
						</S.list>
					) : (
						<S.centralize>
							<S.noPages>Não há páginas</S.noPages>
						</S.centralize>
					)}
				</>
			)}
		</S.container>
	);
}
